<!-- 任务点排名 -->
<template>
  <div>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <a-card v-show="!loading" title="任务创建删除趋势" size="small" :bordered="false">
      <div :id="id" :style="{ height: height, width: width }" />
    </a-card>
  </div>
</template>
<script>
import { taskCreatedDeletedTrend } from '@/api/data/task';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      id: 'task-created-deleted-trend',
      showModal: 'team',
      loading: true,
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18
          }
        ]
      },
      data: []
    };
  },
  watch: {
    filterForm() {
      this.getTaskCreatedDeletedTrend();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    require('echarts/lib/chart/line');
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(document.getElementById(this.id));
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getTaskCreatedDeletedTrend() {
      this.loading = true;
      taskCreatedDeletedTrend({ ...this.filterForm, sorter: 'created_count', show_modal: this.showModal })
        .then(res => {
          this.data = res.data.items;
          const x_axis = [];
          const created_series = [];
          const deleted_series = [];
          this.data.forEach(el => {
            x_axis.push(el.date);
            created_series.push(el.created_count);
            deleted_series.push(el.deleted_count);
          });

          this.option.xAxis.data = x_axis;
          this.option.series = [
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              name: '创建',
              data: created_series
            },
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              name: '删除',
              data: deleted_series
            }
          ];
          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
/deep/.ant-card-small > .ant-card-body {
  padding: 0;
}
</style>
